import { render, staticRenderFns } from "./GithubIcon.vue?vue&type=template&id=4409c929&"
import script from "./GithubIcon.vue?vue&type=script&lang=js&"
export * from "./GithubIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports